/* Publish by EComposer at 2026-10-15 11:32:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-pqg126yhord"]=  window.__ectimmers["ecom-pqg126yhord"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-pqg126yhord').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqg126yhord', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znmv03g0x1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znmv03g0x1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7pli99u2r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7pli99u2r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-acd9d7mxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-acd9d7mxm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbf1aj3orx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbf1aj3orx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-76ra1u43rnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-76ra1u43rnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2edeooqo5gq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2edeooqo5gq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orwa8vxivro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orwa8vxivro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6xx0tgd9dg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6xx0tgd9dg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ertic17lgo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ertic17lgo6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s6ct6eyzhw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s6ct6eyzhw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ebllsh6inpj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ebllsh6inpj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-h0njisdk76d"]=  window.__ectimmers["ecom-h0njisdk76d"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-h0njisdk76d"]["q07tkuzkb"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-h0njisdk76d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0njisdk76d', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9lxwe2y6ulv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9lxwe2y6ulv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pq5jgm7r29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pq5jgm7r29', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9pkx0kjb0mw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9pkx0kjb0mw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bto1on28lmw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bto1on28lmw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7zh6kdrq4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7zh6kdrq4e', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-7vpracb5yyh"]=  window.__ectimmers["ecom-7vpracb5yyh"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-7vpracb5yyh"]["eh70wan2d"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-7vpracb5yyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7vpracb5yyh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-csanuxcjwgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-csanuxcjwgw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8a50w81k63v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8a50w81k63v', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgm7sjzxg3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgm7sjzxg3h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pgdey0g8xhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pgdey0g8xhs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ix2lkbjfajq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ix2lkbjfajq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u6tk8vk0c7p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u6tk8vk0c7p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5dmwg2qkhkj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5dmwg2qkhkj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4pvxf22dfie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4pvxf22dfie', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}